const initialState = {};

export default function newTaskDataReducer(state = initialState, action) {
  switch (action.type) {
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/admin/work-orders/details/new-task.data.js